import { c as _c } from "react/compiler-runtime";
import { formatCents } from 'betterplace-utils';
import { Heading } from '../../../components/Heading';
import styles from './ModalContent.module.css';
export type BudgetInfoText = {
  heading: string;
};
function BudgetInfo(t0) {
  const $ = _c(10);
  const {
    providedAmountInCents,
    text,
    locale
  } = t0;
  let t1;
  if ($[0] !== text.heading) {
    t1 = <Heading as="h3" level="text-md-default">{text.heading}</Heading>;
    $[0] = text.heading;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== locale || $[3] !== providedAmountInCents) {
    t2 = formatCents(locale, providedAmountInCents);
    $[2] = locale;
    $[3] = providedAmountInCents;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <p className={styles.importantInfo}>{t2}</p>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t1 || $[8] !== t3) {
    t4 = <div className={styles.paragraph}>{t1}{t3}</div>;
    $[7] = t1;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}
export default BudgetInfo;